import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { resetSubTypeUpdateStatus, selectIsPreinstall, selectUserInfo } from '@app/redux';

import { DisconnectPageNavigationProps } from '../../index';
import ContactInformation from '../ContactInformation';
import EventBanner from '../EventBanner';
import Footer from '../Footer';
import Survey from '../Survey';
import { Section } from '../../types';

import styles from './index.module.scss';

const LeftSection = ({
  handleCancel,
  handleContinue,
  errorHandling,
}: {
  handleCancel: () => void;
  handleContinue: () => void;
  errorHandling: DisconnectPageNavigationProps['errorHandling'];
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['Disconnect', 'Global']);
  const hasPreinstall = useSelector(selectIsPreinstall);
  const { loading } = useSelector(selectUserInfo);

  const [editableSection, setEditableSection] = useState<Section>(null);
  const editableSectionProps = { editableSection, setEditableSection };

  const handleContinueClick = () => {
    handleContinue();
    dispatch(resetSubTypeUpdateStatus());
  };

  return (
    <>
      <Surface className={styles['leftCardContent']}>
        <EventBanner />
        <div>
          <Txt mb="8px" variant="bodyLargeBold">
            {t('survey.heading')}
          </Txt>
          <Txt variant="bodySmallRegular">{t('survey.description')}</Txt>
        </div>
        <hr className={styles['separator']} />
        <Survey errorHandling={errorHandling} />
        {!hasPreinstall && <ContactInformation {...editableSectionProps} />}
      </Surface>
      <Footer>
        <Button variant="tertiary" onClick={handleCancel}>
          {t('button.cancel')}
        </Button>
        <Button variant="primary" onClick={handleContinueClick} disabled={editableSection !== null || loading}>
          {t('button.continue')}
        </Button>
      </Footer>
    </>
  );
};

export default LeftSection;
